/**
 * Links to shared objects.
 * Will be defined in onSettingsInit.
 */

'use strict';


module.exports = {
    api: null,
    gettext: null
};
